import Vue from 'vue'
import Vuex from 'vuex'
import {db} from '@/FirebaseConfig'

Vue.use(Vuex)
export default {
  namespaced:true,
  state: {
    snackbarMessage: '',
    snackbarShow: false,
    rules: {
      required: value => !!value || 'Requerido.',
      object: obj=>(typeof obj!='undefined') || 'Debe seleccionar una opción',
      notEmpty: arr => arr&&!!arr.length>0 || 'Debe seleccionar al menos una opción',
      minFour: vfour => vfour&&vfour.length >= 4 || 'El campo debe contener al menos 4 carácteres',
      minEight: veight => veight&&veight.length >= 8 || 'El campo debe contener al menos 8 carácteres',
      minNine: vnine => vnine&&vnine.length >= 9 || 'El campo debe contener al menos 9 carácteres',
      mustTwo: vtwo => vtwo && vtwo != 2 || 'El campo debe ser de dos caracteres',
      mustThree: vtwo => vtwo && vtwo != 3 || 'El campo debe ser de tres caracteres',
    },
    valid: true,
    annulDialog: false,
    reverseDialog: false,
    mensaje_de_base_de_datos: '',
    estado_de_mensaje_de_base_de_datos: false,
  },
  mutations: {
    launchSnackbar: (state, message)=>{
      state.snackbarMessage = message 
      state.snackbarShow = true
    }
  },
  actions: {
    obtener_mensaje_de_dase_de_datos: context => {
      db.collection('app').doc('centro_de_mensajes').collection('base_de_datos').doc('ultimo mensaje')
      .onSnapshot(doc=>{
        if (!doc.exists) return
        context.state.mensaje_de_base_de_datos = doc.data().mensaje
        context.state.estado_de_mensaje_de_base_de_datos = false
        setTimeout(()=>{context.state.estado_de_mensaje_de_base_de_datos = true}, 500)
      })
    }
  },
}